<mat-form-field class="input-component" [ngClass]="{'midle-width': inputModel.isMidleWidth, 'example-full-width': !inputModel.isMidleWidth, 'input-custom': inputModel.isInputCurrencyRecharge}">
  <input
    matInput
    type="{{ inputModel.type }}"
    maxlength="{{ inputModel.maxlength }}"
    [textMask]="{mask: inputModel.maskRule, guide: false}"
    placeholder="{{ inputModel.placeholder }}"
    [formControl]="authInputFormControl"
    [(ngModel)]="value"
    (ngModelChange)="sendValue()"
    (change)="isValid()">

  <mat-error [ngClass]="{'auth-error': !inputModel.isAuth}">
    <p *ngIf="authInputFormControl.hasError('required')">Campo Obrigatório</p>
  </mat-error>
  <mat-error *ngFor="let validator of inputModel.validators" [ngClass]="{'auth-error': !inputModel.isAuth}">
    <p *ngIf="!authInputFormControl.hasError('required') && authInputFormControl.hasError(validator.getValidatorsName())">{{ validator.getValidatorsErrorDescription() }}</p>
  </mat-error>
</mat-form-field>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/input.component.html